<template lang="pug">
v-main
  v-container(fluid)
    v-card
        v-toolbar.elevation-0(color="white")
            v-toolbar-title {{ title }}
        v-divider
        v-card-text 
            div(class="d-flex")
                div
                    p.mt-1(class="subtitle__faq") Download i-Memo guide

                    v-btn(depressed class="blue-custom text-capitalize" :href="guideLink", download)
                        img.mr-2(src="../assets/icon/download-v2.svg" color="white")
                        | iMemo Guidance (English)
                //- div(class="ml-auto")
                //-     img(src="assets/faq-illustrator.jpg" class="img-faq")

            v-row.mt-1.pa-4
                p.mt-1(class="subtitle__faq") Have questions? We're here to help.
                v-text-field.hidden-sm-and-down.col-12(
                    outlined
                    prepend-inner-icon="search",
                    placeholder="Search questions",
                    v-model="keyword",
                    hide-details
                    @keyup="getData"
                )

                v-expansion-panels(accordion flat class="mt-5")
                    v-expansion-panel(
                        v-for="(item,i) in faq"
                        :key="i"
                        class="elevation-0"
                    )
                        v-expansion-panel-header(class="custom-header pl-0") {{ item.title }}
                        v-expansion-panel-content(class="custom-subtitle pl-0")
                            div(v-html="item.description")

                    template(v-if="faq.length == 0")
                        div.pa-15.text-center 
                            img(src="../assets/icon/empty-users.png")
                            div(class="empty__title mt-1") No Results Found
                            div(class="empty__subtitle") Please try another search or contact us  for more information

                                        
</template>

<script>
import axios from "axios";
export default {
    name: "FaqUsers",
    props: {
        title: ''
    },
    data() {
        return {
            guideLink: process.env.MEMO_GUIDE_URL || "files/User-Guidance-Generic-iMemo-EN-v4.pdf",
            keyword: "",
            sortBy: "string",
            direction: -1,
            page: 1,
            perPage: 2000,
            faq: [],
            total: null
        }
    },
    mounted() {
        this.getData();
    },
    computed: {
        getLength() {
            return this.total / this.perPage
        },
        getPerPage() {
            if ( this.perPage == -1 || this.total < this.perPage ) {
                return this.total
            } else {
                return this.perPage
            }
        }
    },
    methods: {
        getData() {
            let token = localStorage.getItem("token");
            const config = {
              method: "post",
              url: process.env.VUE_APP_API + `/faq/list`,
              headers: {"Authorization": `Bearer ${token}`},
              data: {
                "role": [
                    "general"
                ],
                "sortBy": "",
                "direction": this.direction,
                "page": this.page,
                "perPage": this.perPage,
                "keyword": this.keyword
              },
            };
            axios(config)
              .then(res => {
                this.faq = res.data.data
                this.total = res.data.total
              })
              .catch(err => {
                console.log(err)
              })
              .finally(() => (this.loading = false));
        }
    }
}
</script>

<style>
button.custom__padding-btn {
  padding: 1.4rem 2rem !important;
}

.v-toolbar__content {
  box-shadow: none;
}

.v-expansion-panel-header.custom-header{
    color: #000000;
    font-weight: 500;
    font-size: 16px;
    border-bottom: 1px solid #DDDDDD;
}

.v-expansion-panel-content__wrap ol li{
    color: #626262;
    margin-bottom: 1em
}

.color-blue{
    color: #1976D2;
}

.color-red{
    color: #F44336;
}

.color-green{
    color: #4CAF50;
}

.color-black{
    color: #121212;
}

.color-orange{
    color: #FF9800;
}

.blue-custom{
    background: #1976D2 !important;
    color: #fff !important;
    font-size: 14px;
    padding: 1.5rem 1rem !important;
}

.img-faq{
    height: 130px;
    width: auto;
}

.custom-subtitle{
    color: #626262;
    padding-top: 1rem;
}

.subtitle__faq{
    font-size: 16px;
    color: #000000;
}
</style>